export const API_LOGOUT_EMIT = 'api:logout';
export const GLOBAL_MODAL_ACTION = 'GLOBAL_MODAL_ACTION';
export const GLOBAL_MODAL_CLOSE = 'GLOBAL_MODAL_CLOSE';
export const GLOBAL_DRAWER_ACTION = 'GLOBAL_DRAWER_ACTION';
export const GLOBAL_DRAWER_CLOSE = 'GLOBAL_DRAWER_CLOSE';
